const BANCOS = ['Interbank', 'BCP', 'Scotiabank', 'Continental']
const TIPOS_CUENTA = ['Ahorro', 'Corriente']

function normalizarBanco (banco) {
  if (!banco) return null
  const valor = String(banco).trim().toUpperCase()
  if (valor === 'BBVA' || valor === 'CONTINENTAL') return 'CONTINENTAL'
  if (valor === 'SCOTIBANK') return 'SCOTIABANK'
  return valor
}

function normalizarTipoCuenta (tipoCuenta) {
  if (!tipoCuenta) return null
  const valor = String(tipoCuenta).trim().toUpperCase()
  if (valor.includes('AHORRO')) return 'AHORRO'
  if (valor.includes('CORRIENTE')) return 'CORRIENTE'
  return valor
}

export function obtenerDigitosRequeridos (banco, tipoCuenta) {
  const bancoNormalizado = normalizarBanco(banco)
  const tipoNormalizado = normalizarTipoCuenta(tipoCuenta)

  if (bancoNormalizado === 'INTERBANK') {
    if (tipoNormalizado === 'CORRIENTE') return 13
    if (tipoNormalizado === 'AHORRO') return 13
    return -1
  }
  if (bancoNormalizado === 'BCP') {
    if (tipoNormalizado === 'AHORRO') return 14
    if (tipoNormalizado === 'CORRIENTE') return 13
    return -1
  }
  if (bancoNormalizado === 'SCOTIABANK') return 10
  if (bancoNormalizado === 'CONTINENTAL') return 18
  return -1
}

export function obtenerEtiquetaCuenta (banco, tipoCuenta) {
  const digitos = obtenerDigitosRequeridos(banco, tipoCuenta)
  if (digitos > 0) {
    return `Número de cuenta de ${digitos} dígitos`
  }
  return 'Número de cuenta'
}

export function sanitizarNumeroCuenta (valor, banco, tipoCuenta) {
  const soloDigitos = String(valor || '').replace(/\D/g, '')
  const maxDigitos = obtenerDigitosRequeridos(banco, tipoCuenta)
  if (maxDigitos <= 0) return soloDigitos
  return soloDigitos.slice(0, maxDigitos)
}

export function validarNumeroCuenta (banco, tipoCuenta, numeroCuenta) {
  if (!banco) return 'Selecciona el banco de destino para continuar'
  if (!tipoCuenta) return 'Selecciona el tipo de cuenta para continuar'

  const digitosRequeridos = obtenerDigitosRequeridos(banco, tipoCuenta)
  if (digitosRequeridos <= 0) return 'Selecciona un tipo de cuenta válido para el banco elegido'

  const cuenta = String(numeroCuenta || '').trim()
  if (!cuenta) return `${obtenerEtiquetaCuenta(banco, tipoCuenta)}. Completa los dígitos faltantes`
  if (!/^\d+$/.test(cuenta)) return 'El número de cuenta debe contener solo números. Verifica el dato ingresado'
  if (cuenta.length < digitosRequeridos) {
    return `${obtenerEtiquetaCuenta(banco, tipoCuenta)}. Completa los dígitos faltantes`
  }
  if (cuenta.length > digitosRequeridos) {
    return `${obtenerEtiquetaCuenta(banco, tipoCuenta)}. Verifica y elimina los dígitos adicionales`
  }
  return ''
}

export { BANCOS, TIPOS_CUENTA }



// WEBPACK FOOTER //
// ./src/utils/prestamosVidaCuentaBancaria.js